<template>
  <div style="display: flex; gap: 8px; align-items: center">
    <!-- Ảnh sản phẩm -->
    <ProductImage :src="product.productImageUrl" />

    <!-- Thông tin sản phẩm -->
    <div>
      <div
        class="productCode"
        @click="linkToProduct(product.productId)"
        style="cursor: pointer; color: #3699ff"
      >
        <span style="font-size: 11px; color: #3699ff">{{
          product.barCode
        }}</span>
      </div>
      <span style="font-size: 12px">({{ product.productCode }})</span>
      <br />
      <p class="m-0" style="font-weight: 500">
        {{ product.productName }}
      </p>
      <p v-if="isShowStockQuantity" class="m-0">
        Tồn: {{ product.inStockQuantity }}
      </p>
    </div>
  </div>
</template>

<script>
import ProductImage from '@/view/components/products/ProductImage.vue';
import _isInteger from 'lodash/isInteger';

export default {
  name: 'ProductCommonInfo',
  components: {
    ProductImage,
  },
  props: {
    product: {
      type: Object,
      required: true,
    },
  },
  computed: {
    isShowStockQuantity() {
      return _isInteger(this.product.inStockQuantity);
    },
  },
  methods: {
    linkToProduct(productId) {
      if (!productId) {
        return;
      }
      this.$router.push({
        name: 'inventory-detail',
        query: { id: productId },
      });
    },
  },
};
</script>

<style scoped>
.productCode:hover {
  text-decoration: underline;
  cursor: pointer;
}
</style>
